<template>
  <div>
    <h1 class="settings-title">
      Notifications
    </h1>
    <div
      class="settings-form">
      <h2 class="settings-subtitle">
        Settings
      </h2>
      <b-form-group>
        <label
          for="notification-sound"
          class="settings-label">
          Play Notification Sound
        </label>
        <SwitchCheckbox
          id="notification-sound"
          v-model="soundEnabled"
          @input="switchSound"/>
      </b-form-group>
      <b-form-group>
        <label
          for="subscriber-notification"
          class="settings-label">
          <span>Notify Me About New Subscriber</span>
          <icon
            id="subscriber-notification-description"
            v-b-tooltip="getTooltipConfig('You\'ll receive email/browser notification when your business gets a new subscriber.')"
            name="info-circle"
            class="info-label"/>
        </label>
        <SwitchCheckbox
          id="subscriber-notification"
          v-model="subscriberNotification"
          @input="saveUserSettings"/>
      </b-form-group>
      <b-form-group>
        <label
          for="message-notification"
          class="settings-label">
          <span>Notify Me About New Message</span>
          <icon
            id="message-notification-description"
            v-b-tooltip="getTooltipConfig('You\'ll receive email/browser/WhatsApp notification if you are offline and your business received a new message.')"
            name="info-circle"
            class="info-label"/>
        </label>
        <SwitchCheckbox
          id="message-notification"
          v-model="messageNotification"
          @input="saveUserSettings"/>
      </b-form-group>
    </div>
    <hr
      v-if="!phone || !email">
    <div
      v-if="!phone"
      class="info">
      <p>You did not set a phone number to receive WhatsApp notification.</p>
      <router-link
        :to="{ name: 'PhoneSettings' }"
        tag="p"
        class="link">&nbsp; Click here to add phone</router-link>
    </div>
    <div
      v-if="!email"
      class="info">
      <p>You did not set an email to receive notification.</p>
      <router-link
        :to="{ name: 'EmailSettings' }"
        tag="p"
        class="link">&nbsp; Click here to add email</router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.info {
  p {
    display: inline-block;
    font-size: 14px;
    &.link {
      color: $bluePrimary;
      cursor: pointer;
    }
  }

  .account-settings__submit {
    margin-top: 0!important;
    font-size: 12px;
  }
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex';
import SwitchCheckbox from '../common/SwitchCheckbox';

export default {
  name: 'UserNotificationSettings',
  components: {
    SwitchCheckbox,
  },
  data() {
    return {
      soundEnabled: false,
      messageNotification: false,
      subscriberNotification: false,
    };
  },
  computed: {
    ...mapGetters({
      userSettings: 'user/settings',
      phone: 'user/phone',
      email: 'user/email',
    }),
  },
  watch: {
    userSettings: {
      handler(settings) {
        this.messageNotification = settings.message_notification;
        this.subscriberNotification = settings.subscriber_notification;
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchUser();
    if (this.$cookies.isKey('notification_sound')) {
      this.soundEnabled = this.$cookies.get('notification_sound') === 'on';
    } else {
      this.soundEnabled = true;
    }
    this.fetchUserSettings();
  },
  methods: {
    ...mapActions({
      fetchUserSettings: 'user/fetchSettings',
      updateUserSettings: 'user/updateSettings',
      fetchUser: 'user/fetchUser',
    }),
    switchSound(soundEnabled) {
      const soundStatus = soundEnabled ? 'on' : 'off';
      this.$cookies.set('notification_sound', soundStatus, '1y');
      this.$eventBus.$emit('notificationSoundSwitched', soundStatus);
    },
    getTooltipConfig(text) {
      return {
        title: text,
        placement: 'right',
        animation: false,
        offset: '0, 5px',
      };
    },
    saveUserSettings() {
      this.updateUserSettings({
        message_notification: this.messageNotification,
        subscriber_notification: this.subscriberNotification,
      });
    },
  },
};
</script>
